export default __webpack_public_path__ + "static/media/MRDOnIcon.ec06b7bb.svg";